module.exports = __webpack_public_path__ + "static/img/22.330aba8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/csfish/22.png
// module id = n1ky
// module chunks = 0